import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Calendar, TrendingUp, Target, Award, Users, BarChart } from 'lucide-react';

const BwinNews = () => {
  return (
    <div className="min-h-screen bg-book-cream">
      <Header />
      <main className="book-section">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center space-x-2 mb-4">
              <Calendar className="h-6 w-6 text-book-brown" />
              <span className="text-book-brown-dark font-medium">10.12.2025</span>
              <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm font-medium">Innovation</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-book-brown mb-6">
              Bwin Launches Revolutionary Live Casino Experience
            </h1>
            <p className="text-xl text-book-brown-dark leading-relaxed">
              Global gaming powerhouse unveils cutting-edge live dealer studios with professional UK croupiers, bringing authentic casino atmosphere
              to online players with crystal-clear streaming and interactive features.
            </p>
          </div>

          <div className="mb-12 bg-gradient-to-br from-book-brown to-book-brown-light rounded-xl p-8 text-center text-book-cream">
            <TrendingUp className="h-16 w-16 mx-auto mb-4 opacity-80" />
            <img
              src="/images/eyestetix-studio--kTQitsL0Is-unsplash.webp"
              alt="Bwin Live Casino"
              className="w-full h-64 object-cover rounded-lg"
            />
            <p className="text-sm opacity-75">Revolutionary Live Gaming</p>
          </div>

          <div className="mb-16 bg-book-beige rounded-xl p-8 shadow-book-inset">
            <h2 className="text-2xl font-bold text-book-brown mb-6 text-center">Our News Curation Philosophy</h2>
            <div className="prose prose-lg max-w-none text-book-brown-dark leading-relaxed">
              <p>Every guide published on Brit Ember represents extensive research and deep industry insights...</p>
            </div>
          </div>

          <div className="prose prose-lg max-w-none text-book-brown-dark leading-relaxed mb-12">
            <h2 className="text-3xl font-bold text-book-brown mb-6">Redefining Live Casino Entertainment</h2>
            <p>Bwin's revolutionary live casino experience represents a paradigm shift in online gaming...</p>
          </div>

          <div className="mb-12">
            <h2 className="text-3xl font-bold text-book-brown mb-8 text-center">Live Casino Innovation Metrics</h2>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl shadow-book p-6">
                <h3 className="text-xl font-bold text-book-brown mb-4 text-center">Streaming Quality Index</h3>
                <div className="flex justify-center mb-4">
                  <div className="relative w-48 h-48">
                    <svg viewBox="0 0 100 100" className="w-full h-full">
                      <circle cx="50" cy="50" r="40" fill="none" stroke="#FFD700" strokeWidth="20"/>
                      <circle cx="50" cy="50" r="40" fill="none" stroke="#8B4513" strokeWidth="20" strokeDasharray="125.66" strokeDashoffset="25.13"/>
                    </svg>
                    <div className="absolute inset-0 flex items-center justify-center">
                      <span className="text-2xl font-bold text-book-brown">95%</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-book p-6">
                <h3 className="text-xl font-bold text-book-brown mb-4 text-center">UK Croupier Satisfaction</h3>
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark">Professionalism</span>
                    <span className="font-semibold text-green-600">98%</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark">Engagement</span>
                    <span className="font-semibold text-green-600">96%</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark">Authenticity</span>
                    <span className="font-semibold text-green-600">97%</span>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-book p-6">
                <h3 className="text-xl font-bold text-book-brown mb-4 text-center">Interactive Features</h3>
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark">Chat Integration</span>
                    <div className="w-16 bg-green-500 rounded-full h-3"></div>
                    <span className="font-semibold text-green-600">100%</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark">Multi-Camera</span>
                    <div className="w-14 bg-green-500 rounded-full h-3"></div>
                    <span className="font-semibold text-green-600">95%</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark">VIP Tables</span>
                    <div className="w-12 bg-yellow-500 rounded-full h-3"></div>
                    <span className="font-semibold text-yellow-600">80%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="prose prose-lg max-w-none text-book-brown-dark leading-relaxed">
            <p>Bwin's revolutionary live casino experience represents a paradigm shift in online gaming...</p>
            <div className="bg-book-beige rounded-lg p-6 my-8">
              <h4 className="text-xl font-bold text-book-brown mb-4">Key Innovations</h4>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <Target className="h-5 w-5 text-book-brown mr-3 mt-0.5 flex-shrink-0" />
                  <span>Crystal-clear 4K streaming with professional UK croupiers</span>
                </li>
                <li className="flex items-start">
                  <Award className="h-5 w-5 text-book-brown mr-3 mt-0.5 flex-shrink-0" />
                  <span>Interactive chat features and real-time player engagement</span>
                </li>
                <li className="flex items-start">
                  <Users className="h-5 w-5 text-book-brown mr-3 mt-0.5 flex-shrink-0" />
                  <span>Multi-camera angles providing comprehensive game views</span>
                </li>
                <li className="flex items-start">
                  <BarChart className="h-5 w-5 text-book-brown mr-3 mt-0.5 flex-shrink-0" />
                  <span>Advanced analytics and betting strategy tools</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default BwinNews;
